import { Stack } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';

import { getPresentationProofsByOwnerOptions } from '@/module/Author/Presentation/Proof';

import { ProofCard } from '@feature/proof';
import { Id } from '@feature/utils';

interface PresentationOwnerProofListProps {
  presentationId: Id;
  userId: Id;
}

export function PresentationOwnerProofList({ presentationId, userId }: PresentationOwnerProofListProps) {
  const { data: proofs } = useSuspenseQuery(getPresentationProofsByOwnerOptions(presentationId, userId));

  return (
    <Stack gap="xs">
      {proofs.map(proof => (
        <ProofCard
          key={proof.id}
          proof={proof}
          entity="presentation"
          canEdit={false}
          isPending={false}
        />
      ))}
    </Stack>
  );
}
